<div
role="button"
[ngClass]="{dropzone: true, disabled: disabled, active: status === Status.Active, error: errors?.length > 0, success: errors?.length === 0 && file}"
(click)="onClick()"
(dragover)="onDragOver($event)"
(dragleave)="onDragLeave($event)"
(drop)="onDrop($event)">
  <div *ngIf="!url && errors.length > 0">
    <ng-container *ngTemplateOutlet="errorholder ? errorholder : defaultErrorholder; context: {errors: errors}"></ng-container>
  </div>
  <div *ngIf="!url && errors.length == 0">
    <ng-container  *ngTemplateOutlet="placeholder ? placeholder : defaultPlaceholder"></ng-container>
  </div>
  <img *ngIf="url" [src]="url" />
</div>
<button class="btn btn-primary" [class.clear]="file" [class.hidden]="file && !clearable" [class.disabled]="disabled" (click)="onClick()">
  <img src="assets/images/icons/upload.svg" class="icon" alt="">
</button>

<ng-template #defaultPlaceholder>
  <ng-container i18n="@@fileUploader.placeholder">Upload File</ng-container>
</ng-template>

<ng-template #defaultErrorholder let-errors="errors">
    <img src="assets/images/icons/error.svg" alt="" class="icon">
    <div class="text-sm text-danger" *ngFor="let error of errors">
      <ng-container [ngSwitch]="error">
        <ng-container *ngSwitchCase="UploadError.Size">File size exceeds, maximum size allowed is {{maxSize}}KB</ng-container>
        <ng-container *ngSwitchCase="UploadError.Type">File type is not allowed, allowed file types are {{allowedTypes.join(', ')}}</ng-container>
      </ng-container>
    </div>
</ng-template>